<template>
    <div class="home">
        <Topbar />
        <div class="container-fluid text-left" style="margin-top: 72px; justify-content: center; display: flex">
            <!-- Content Row -->
            <div class="card shadow mb-4 col-md-6 p-0">
                <div class="card-header pt-1 pb-1 small" :style="{ backgroundColor: moduloAtual().color }">
                    <span class="m-0 font-weight-bold text-white">
                        <span v-if="dados.cliente != null">Picking: {{ id }} - {{ dados.cliente }}</span>
                        <span v-else>Carregando... </span>
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </span>
                </div>
                <fieldset v-if="dados.cliente != null" :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark">
                        <div>
                            <div class="text-center col-auto p-0">
                                <label for=""><b>Vá ao endereço 
                                <span class="text-danger" v-if="url.includes('localhost') || url.includes('hkcoletor')">{{ proximoEndereco }}</span>
                                <span class="text-danger no-copy" v-if="!url.includes('localhost') && !url.includes('hkcoletor')">{{ proximoEndereco }}</span>
                                </b></label>
                                <br>
                                <div class="col p-0">
                                    <div class="col p-0 text-left">
                                        <label for="pesquisa">Endereço: </label>
                                    </div>
                                    <div class="col p-0">
                                        <InputDefaultApp
                                            inputPlaceHolderSufixo="Digite o endereço aqui"
                                            titleScan="Escanear endereço"
                                            typeInputMode="text"
                                            @displayScanFunction="onDecode"
                                            @input="handleInput"
                                            :enterKey="handleInputEnter"
                                            idInput="endereco"
                                            autofocus
                                            v-model="endereco"
                                            :errorMessage="errors.endereco ? errors.endereco[0] : ''"
                                            :showChangeInputMode="url.includes('localhost') || url.includes('hkcoletor')"
                                        >
                                        </InputDefaultApp>
                                    </div>
                                </div>
                            </div>

                            <div class="row px-2">
                                <div class="col-lg-12 table-responsive">
                                    <table class="table-sm">
                                        <thead>
                                            <tr style="white-space: nowrap">
                                                <th>Próximos Endereços</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="line in proximosEnderecos"
                                                :key="line"
                                                :style="{
                                                    backgroundColor: '#' + line.statusbackground,
                                                    color: '#' + line.statuscolor,
                                                }"
                                            >
                                                <td>
                                                    <div>
                                                        <div style="display: flex; justify-content: space-between">
                                                            <span class="text-left">{{ line }}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <ForbiddenModal />
        <LogoutModal />
        <Modal
            id="warningModal"
            title="Aviso"
            :confirmFunction="okWarningModal"
            :carregando="carregando"
            confirmText="Ok"
        >
            {{ message }}
        </Modal>
        <Modal
            id="scanModal"
            title="Escanear"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="fecharScan"
        >
            <StreamBarcodeReader v-if="scanAberto" @decode="onDecode" @loaded="onLoaded" @error="onError"></StreamBarcodeReader>
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from "@/components/Topbar.vue";
import LogoutModal from "@/components/LogoutModal.vue";
import ViewMixin from "./ViewMixin";
import api, { setEnderecoAtual } from "../services/api";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    EnderecoDiferenteException,
    ListaConcluidaException,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import { enterKey, dateFormat, selecionar } from "../utils";
import ForbiddenModal from "../components/ForbiddenModal.vue";
import InputDefaultApp from "../components/InputDefaultApp.vue";
import Modal from "../components/Modal.vue";
import { StreamBarcodeReader } from "vue-barcode-reader";
import Audio from "../services/audioService";

export default {
    name: "EnderecosPicking",
    mixins: [ViewMixin],
    components: {
        Topbar,
        LogoutModal,
        ForbiddenModal,
        Modal,
        StreamBarcodeReader,
        InputDefaultApp
    },
    props: ["id"],
    data: () => {
        return {
            url: window.location.href,
            idname: "idlista",
            baseUrl: "picking/enderecos",
            title: {
                icon: "fas fa-cash-register",
                text: "Picking",
            },
            sort: "nome",
            sortDirection: "asc",
            filtro: {
                pesquisa: "",
            },
            arquivoLabel: "Selecionar Arquivo",
            arquivoNome: "",
            arquivos: null,
            proximoEndereco: null,
            proximosEnderecos: [],
            endereco: "",
            scanAberto: false,
        };
    },
    mounted() {
        this.list();
    },
    methods: {
        enterKey,
        dateFormat,

        async list() {
            this.carregando = true;

            try {

                let { baseUrl, sort, sortDirection, filtro, perPage, pular, id } = this;
                let response = await api.get(`/${baseUrl}/${id}`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                response.data.enderecos.forEach((e, i) => {
                    if (i === 0) {
                        this.proximoEndereco = e
                    } else {
                        this.proximosEnderecos.push(e)
                    }
                }, this);
                this.dados = response.data;

                setTimeout(() => {
                    selecionar('#endereco')
                }, 100);

            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                    setTimeout(() => {
                        this.carregando = false;
                    }, 100);
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push('/picking/enderecos/' + this.id)
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                console.error(e);
            }

            this.carregando = false;
        },

        async importarPlanilha() {
            this.carregando = true;

            try {
                $("#filtrocardImportacao").collapse("hide");

                let { baseUrl, arquivos } = this;
                const formData = new FormData();
                for (let i = 0; i < arquivos.length; i++) {
                    formData.append(`files[${i}]`, arquivos[i]);
                }

                await api.post(`/${baseUrl}/importar`, formData, {
                    headers: { "content-type": "multipart/form-data" },
                });

                this.dados = [];
                this.list();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                    console.error(e);
                }
            }

            this.carregando = false;
        },

        async exportar() {
            try {
                const response = await this.apiExport();
                const today = new Date().toISOString().slice(0, 10);
                const fileName = `${this.title.text}_${today}.csv`;
                const blobURL = URL.createObjectURL(new File([response.data], fileName));
                const a = document.createElement("a");
                a.href = blobURL;
                a.style = "display: none";
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
            } catch (e) {
                console.error(e);
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }
            this.carregando = false;
        },

        async apiExport() {
            this.carregando = true;

            let { pular, perPage } = this;

            const response = await api.get(`/${this.baseUrl}/exportar`, {
                responseType: "blob",
                params: {
                    pular,
                    perPage,
                    sort: `${this.sort} ${this.sortDirection}`,
                    ...this.filtro,
                },
            });

            this.carregando = false;

            return response;
        },

        okWarningModal() {
            let { exception } = this;
            $("#warningModal").modal("hide");
            if (exception instanceof ListaConcluidaException || exception instanceof ClientErrorException) {
                this.$router.push('/picking')
            }
        },

        handleInput(e) {

            this.endereco = e.data; // garante sincronização

            this.errors = []
            let valor = (typeof e === 'string') ? e : this.endereco;
            if (valor == this.proximoEndereco) {
                setEnderecoAtual(valor)
                this.$router.push('/picking/proximo-item/' + this.id)
            }
        },

        handleInputEnter(e) {

            this.endereco = e.data; // garante sincronização
            
            if (this.endereco != this.proximoEndereco) {
                Audio.ops();
                this.handleValidationException(new ValidationException({endereco: ["Endereço Inválido"]}, ""));
                setTimeout(() => {
                    selecionar('#endereco')
                }, 100);
            }
        },

        abrirScan() {
            this.scanAberto = true;
            $("#scanModal").modal("show");
        },
        fecharScan() {
            this.scanAberto = false;
            $("#scanModal").modal("hide");
        },
        onDecode(r) {
            this.endereco = r;

            setTimeout(() => {
                this.handleInput(null);
            }, 100);
        },
        onError(r) {
            console.log(r)
            alert("Não foi possível escanear")
        },
        onLoaded() {
            console.log("Scaneando código de barras ou QR Code!");
        },
    },
};
</script>

<style scoped lang="scss">
.spinner-grow {
    width: 1em;
    height: 1em;
}

.no-copy {
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE/Edge antigo */
  user-select: none;         /* padrão */
}

</style>
